import PropTypes from 'prop-types'
import { Icon } from '@artprov/design-system'
import { cn } from '../../_utils/cn'
import { menuVariants } from '../variants/Menu.variants'

/**
 * @param {Object} props
 * @param {boolean} [props.hasChildren]
 * @param {string} [props.className]
 */
export const MenuItemChevron = ({ hasChildren, className }) => {
  if (!hasChildren) return null

  return (
    <span className={cn(menuVariants.itemChevron(), className)} aria-hidden="true">
      <Icon icon="chevron_forward" size="small" />
    </span>
  )
}

MenuItemChevron.propTypes = {
  hasChildren: PropTypes.bool,
  className: PropTypes.string,
}
